export default __webpack_public_path__ + "static/media/prana02a.b04acae9.JPG";